'use client'

/**
 * Let's leave this file here, but according to the following github issue,
 * these aren't reliably rendering in 14.X versions
 * https://github.com/vercel/next.js/issues/55462
 */

export default function GlobalError({ reset }: { reset: () => void }) {
  return (
    <html>
      <body>
        <h2>Something went wrong!</h2>
        <button onClick={() => reset()}>Try again</button>
      </body>
    </html>
  )
}
